<template>
  <div class="container-fluid nav-bar bg-transparent">
    <nav class="navbar navbar-expand-lg bg-white navbar-light py-0 px-4">
      <router-link to="/" class="navbar-brand d-flex align-items-center text-center">
        <div class="icon p-2 me-2">
          <img class="img-fluid" src="/img/real-estate.png" alt="Icon" style="width: 30px; height: 30px" />
        </div>
        <h1 class="m-0 text-primary">Estate Rwanda</h1>
      </router-link>
      <button
        type="button"
        class="navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="navbar-nav ms-auto">
          <router-link to="/" class="nav-item nav-link" :class="{ active: currentRoute === '/' }">Home</router-link>
          <router-link to="/about" class="nav-item nav-link" :class="{ active: currentRoute === '/about' }">About</router-link>
          <div class="nav-item dropdown">
            <router-link
              to="/properties"
              class="nav-link dropdown-toggle"
              :class="{ active: currentRoute.startsWith('/properties') || propertyRoutes.includes(currentRoute) }"
              data-bs-toggle="dropdown"
            >Property</router-link>
            <div class="dropdown-menu rounded-0 m-0">
              <router-link to="/buy-properties" class="dropdown-item">Buy</router-link>
              <router-link to="/rent-properties" class="dropdown-item">Rent</router-link>
              <router-link to="/property-list" class="dropdown-item">Property List</router-link>
              <!-- <router-link to="/property-type" class="dropdown-item">Property Type</router-link>
              <router-link to="/agents" class="dropdown-item">Property Agent</router-link> -->
            </div>
          </div>
          <router-link to="/contact" class="nav-item nav-link" :class="{ active: currentRoute === '/contact' }">Contact</router-link>
        </div>
        <a href="https://agents.estaterwanda.com/" class="btn btn-primary px-3 d-none d-lg-flex">Add Property</a>
      </div>
    </nav>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup () {
    const route = useRoute()
    const currentRoute = computed(() => route.path)
    const propertyRoutes = [
      '/buy-properties',
      '/rent-properties',
      '/property-list',
      '/property-type',
      '/agents'
    ]

    return {
      currentRoute,
      propertyRoutes
    }
  }
})
</script>

<style scoped>
.navbar {
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000
}
</style>
